<template>
  <div class="users container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3 class="text-themecolor">Rider Details</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">User Details</li>
            </ol>
        </div>
    </div>

    <div v-if="user" class="row">
      <div class="col-12 col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title"><span class="lstick"></span>Rider Profile</h4>
              <div v-if="getUser()['is_agent'] || getUser()['is_admin'] || getUser()['is_superuser']" class="btn-group ml-auto m-t-10">
                <a href="JavaScript:void(0)" class="icon-options-vertical link" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>
                <div class="dropdown-menu dropdown-menu-right">
                  <a class="dropdown-item" @click="showDriverSelectModalAction('favorite')">Add Favorite Driver</a>
                  <a class="dropdown-item" @click="showDriverSelectModalAction('blacklist')">Add Blacklist Driver</a>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-12 text-center mb-3 row">
              <div class="col-12">
                  <img v-if="user.id_profile_image" class="rounded-circle" style="height: 100px; width: 100px; object-fit: cover;"
                      :src="user.id_profile_image.url"
                      alt="No profile picture">
                <font-awesome-icon v-if="!user.id_profile_image" icon="user-circle" style="height: 100px; width: 100px; color: grey;"/>
                <div class="col-12">
                  <span class="font-weight-bold text-center">{{ user.name_first }} {{ user.name_last }}</span>
                </div>
              </div>
            </div>

            <div class="col-12">
              <span class="font-weight-bold">Market:</span> {{user.id_market ? user.id_market.name : 'N/A'}}
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Rides completed:</span> {{user.rider_rides_amount}}
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Referrer:</span> {{ user.id_referrer ? user.id_referrer.name_first : 'N/A' }}
            </div>
            <div class="col-12">
              <hr>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Phone:</span>
              <a v-if="user.phone_number != null" href="https://countrycode.org/US">[US] {{ user.phone_number }}</a>
              <span v-else>N/A</span>
            </div>
            <div class="col-12">
              <span class="font-weight-bold">Email:</span>
              {{ user.email }}
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
              <div class="d-flex">
                  <h4 class="card-title"><span class="lstick"></span>Comments</h4>
              </div>
          </div>
          <div class="card-body">
            <div class="col-12 table-responsive">
              <table id="comments-table" class="table table-sm table-hover">
                <thead ><tr><td style="border:none;"></td></tr></thead>
                <tbody>
                  <tr v-for="comment in comments" class="col-12 mt-2 p-3" v-bind:style="comment.content_type == 'action' ? 'background-color:#f3f1f1' : ''">
                    <td>
                      <p class="pull-right">
                        <small>{{ comment.created_at | moment('timezone', user.location_timezone, "MMMM Do, YYYY \\at h:mm a") }}</small>
                      </p>
                      <div class="media-body">
                        <h6 class="media-heading user_name">{{ comment.commented_by.name_first + ' ' + comment.commented_by.name_last}}</h6>
                        <p>{{comment.content}}</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-12 mt-2 p-3">
                <textarea class="form-control form-sm" style="height: 100px;" name="comment[comment]"
                          id="comment_comment" v-model="comment_content"></textarea>
              <input @click="addComment()" type="submit" name="commit" value="Add Comment"
                     class="btn btn-info waves-effect waves-light m-t-10" data-disable-with="Add Comment">
            </div>

          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="card">
          <div class="card-body">
              <div class="d-flex">
                  <h4 class="card-title"><span class="lstick"></span>Upcoming Rides</h4>
              </div>
          </div>
          <div class="card-body">
            <div class="col-12 table-responsive">
              <table id="upcoming-rides-table" class="table table-hover table-sm">
                <thead>
                  <tr>
                    <th>#ID</th>
                    <th>Infos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!upco || upco.length==0">
                    <td colspan="2" style="text-align: center;">
                      N/A
                    </td>
                  </tr>
                  <template v-for="ride in upco">
                    <tr>
                      <td>
                        <router-link :to="'/rides/' + ride.id_ride + '/'">
                          #{{ ride.id_ride }}
                        </router-link>
                      </td>
                      <td>
                        <div>
                          <span class="font-weight-bold ">Departure:</span>
                          {{ ride.date_pickup | moment('timezone', user.location_timezone, "YYYY-MM-DD HH:mm") }}
                        </div>
                        <div>
                          <span class="font-weight-bold ">From:</span>
                          {{ ride.default_pickup_address }}
                        </div>
                        <div>
                          <span class="font-weight-bold ">To:</span>
                          {{ ride.default_dropoff_address }}
                        </div>
                        <div>
                          <span class="font-weight-bold ">Duration:</span>
                          {{ Number((ride.default_duration_p_to_d/60).toFixed(1)) }}
                          minutes
                          <span class="font-weight-bold ">Distance:</span>
                          {{ (ride.default_distance_p_to_d).toFixed(2) }}
                          miles
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
              <div class="d-flex">
                  <h4 class="card-title"><span class="lstick"></span>Previous Rides</h4>
              </div>
          </div>
          <div class="card-body">
            <div class="col-12 table-responsive">
              <table id="previous-rides-table" class="table table-hover table-sm">
                <thead>
                  <tr>
                    <th>#ID</th>
                    <th>Infos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!prev || prev.length==0">
                    <td colspan="2" style="text-align: center;">
                      N/A
                    </td>
                  </tr>
                  <template v-for="ride in prev">
                    <tr>
                      <td>
                        <router-link :to="'/rides/' + ride.id_ride + '/'">
                          #{{ ride.id_ride }}
                        </router-link>
                      </td>
                      <td>
                        <div>
                          <span class="font-weight-bold ">Departure:</span>
                          {{ ride.date_pickup | moment('timezone', user.location_timezone, "YYYY-MM-DD HH:mm") }}
                        </div>
                        <div>
                          <span class="font-weight-bold ">From:</span>
                          {{ ride.default_pickup_address }}
                        </div>
                        <div>
                          <span class="font-weight-bold ">To:</span>
                          {{ ride.default_dropoff_address }}
                        </div>
                        <div>
                          <span class="font-weight-bold ">Duration:</span>
                          {{ Number((ride.default_duration_p_to_d/60).toFixed(1)) }}
                          minutes
                          <span class="font-weight-bold ">Distance:</span>
                          {{ (ride.default_distance_p_to_d).toFixed(2) }}
                          miles
                        </div>
                      </td>
                    </tr>
                    <!-- <tr>
                      <td rowspan="4">
                        <router-link :to="'/rides/' + ride.id_ride + '/'">
                          #{{ ride.id_ride }}
                        </router-link>
                      </td>
                      <td>
                        <span class="font-weight-bold ">Departure:</span>
                        {{ ride.date_pickup | moment('timezone', user.location_timezone, "MMMM Do, YYYY \\at h:mm a") }}
                      </td>
                    </tr>
                    <tr>
                      <td><span class="font-weight-bold ">From:</span>
                        {{ ride.default_pickup_address }}
                      </td>
                    </tr>
                    <tr>
                      <td><span class="font-weight-bold ">To:</span>
                        {{ ride.default_dropoff_address }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span class="font-weight-bold ">Duration:</span>
                        {{ Number((ride.default_duration_p_to_d/60).toFixed(1)) }}
                        minutes
                        <span class="font-weight-bold ">Distance:</span>
                        {{ ride.default_distance_p_to_d/1000 }}
                        miles
                      </td>
                    </tr> -->
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title"><span class="lstick"></span>Favorite Drivers</h4>
            </div>
          </div>
          <div class="card-body">
            <div class="col-12 table-responsive">
              <table id="previous-rides-table" class="table table-hover table-sm">
                <thead>
                  <tr>
                    <th>#ID</th>
                    <th>Driver</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!data.favoriteDrivers || data.favoriteDrivers.length==0">
                    <td colspan="1" style="text-align: center;">
                      N/A
                    </td>
                  </tr>
                  <template>
                    <tr v-for="driver in data.favoriteDrivers">
                      <td class="text-primary result-item">
                        <router-link :to="'/drivers/' + driver.id_user + '/'">
                          #{{ driver.id_user }}
                        </router-link>
                      </td>
                      <td>
                        {{ driver.name_first + " " + driver.name_last}}
                      </td>
                      <td v-if="getUser()['is_agent'] || getUser()['is_admin'] || getUser()['is_superuser']">
                        <font-awesome-icon @click="editDriver(driver.id_user, 'remove', 'favorite')" icon="times" style="color: #ef5350; cursor: pointer"/>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title"><span class="lstick"></span>Blacklist Drivers</h4>
            </div>
          </div>
          <div class="card-body">
            <div class="col-12 table-responsive">
              <table id="previous-rides-table" class="table table-hover table-sm">
                <thead>
                  <tr>
                    <th>#ID</th>
                    <th>Driver</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!data.blacklistDrivers || data.blacklistDrivers.length==0">
                    <td colspan="1" style="text-align: center;">
                      N/A
                    </td>
                  </tr>
                  <template>
                    <tr v-for="driver in data.blacklistDrivers">
                      <td class="text-primary result-item">
                        <router-link :to="'/drivers/' + driver.id_user + '/'">
                          #{{ driver.id_user }}
                        </router-link>
                      </td>
                      <td>
                        {{ driver.name_first + " " + driver.name_last}}
                      </td>
                      <td v-if="getUser()['is_agent'] || getUser()['is_admin'] || getUser()['is_superuser']">
                        <font-awesome-icon @click="editDriver(driver.id_user, 'remove', 'blacklist')" icon="times" style="color: #ef5350; cursor: pointer"/>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Driver selection popup alert -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="data.showDriverSelectModal" @close="data.showDriverSelectModal = false">
          <h3 slot="header">
            Please select a driver to {{data.currentDriverSelect}}
          </h3>
          <div slot="body">
            <form v-on:submit.prevent class="form-material">
              <br>
              <br>
              <select id="driver-selection" type="text" placeholder="Driver"
                      class="form-control ddown">
                <option>
                  {{data.driverSelectMessage}}
                </option>
                <!-- <option v-for="(item) in data.drivers">
                  {{item.id_user + " - " + item.name_first + " || " + item.name_last}}
                </option> -->
                <option v-for="(item) in data.drivers" v-bind:key="item.id_driver.id" v-if="!item.id_driver.id_market || !user.id_market || item.id_driver.id_market.id_market == user.id_market.id_market">
                  <!-- {{ (item.id_user ? item.id_user + " - " : '') + (item.name_first ? item.name_first : '') + " " + (item.name_last ? item.name_last : '') + ' - ' + (item.id_driver.id_type_driver_account ? item.id_driver.id_type_driver_account.code : 'N/A') + ' - ' + (item.id_driver.id_market ? item.id_driver.id_market.name : 'N/A') + ' - ' + (item.id_driver.id_type_driver_status ? item.id_driver.id_type_driver_status.name : 'N/A') }} -->
                  {{ (item.id_user ? item.id_user + " - " : '') + (item.name_first ? item.name_first : '') + " " + (item.name_last ? item.name_last : '') + ' - ' + (item.id_driver.id_market ? item.id_driver.id_market.name : 'N/A') }}

                </option>
              </select>
            </form>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="fbDriver($event, 'add', data.currentDriverSelect), data.showDriverSelectModal = false">
              Submit
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="data.showDriverSelectModal = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  // register modal component
  Vue.component('modal', {
    template: '#modal-template'
  })

  export default {
    metaInfo: {
      title: 'Wingz Support | Riders',
    },
    name: 'Users',
    data () {
      return {
        isLoading: false,
        user: null,
        prev: null,
        upco: null,
        comments: [],
        comment_content: null,
        data: {
          showDriverSelectModal: false,
          drivers: [],
          favoriteDrivers: null,
          blacklistDrivers: null,
          currentDriverSelect: null,
          driverSelectMessage: "Select A Driver"
        }
      }
    },
    components: {
      Loading
    },
    methods: {
      getComments: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'user-comments/?id_user=' + this.$route.params.id_user + '&page_size=999')
          .then(response => {
            console.log("getComments response: ", response.data)
            this.comments = response.data.results.reverse()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)
            this.errored = true
          })
          .finally(() => {
            this.isLoading = false
            if (this.comments && this.comments.length > 0) {
              $('#comments-table').DataTable({
                displayLength: 5,
                lengthMenu: [5, 10, 25, 50 ],
                lengthChange: true,
                searching: false,
                ordering:  false,
                retrieve: true
              })
            }
          })
      },
      addComment: function () {
        this.isLoading = true
        this.$http
          .post(process.env.API_BASE_URL_CS + 'user-comments/', {
            id_user: this.$route.params.id_user,
            content: this.comment_content
          })
          .then(response => {
            console.log(response.data)
            // this.comments.push(response.data)
            this.comment_content = null
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)
            this.errored = true
          })
          .finally(() => {
            this.isLoading = false
            this.getComments()
          })
      },
      getUserProfile: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'users/?id_user=' + this.$route.params.id_user)
          .then(response => {
            console.log('getUser response: ', response)
            this.user = (response.data.results ? response.data.results[0] : null)
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => {
            this.isLoading = false

            this.getUpco()
          })
      },
      getUpco: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'rides/?type=upco&page_size=10&id_rider=' + this.$route.params.id_user)
          .then(response => {
            console.log('getUpco results: ', response.data)
            this.upco = (response.data.results ? response.data.results : null)
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => {
            if (this.upco && this.upco.length > 0) {
              $('#upcoming-rides-table').DataTable({
                displayLength: 5,
                lengthMenu: [5, 10, 25, 50 ],
                lengthChange: true,
                searching: false,
                ordering:  false,
                retrieve: true
              })
            }
            this.isLoading = false
            this.getPrev()
          })
      },
      getPrev: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'rides/?type=prev&page_size=10&id_rider=' + this.$route.params.id_user)
          .then(response => {
            console.log('getPrev response: ', response.data)
            this.prev = (response.data.results ? response.data.results : null)
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => {
            if (this.prev && this.prev.length > 0) {
              $('#previous-rides-table').DataTable({
                displayLength: 5,
                lengthMenu: [5, 10, 25, 50 ],
                lengthChange: true,
                searching: false,
                ordering:  false,
                retrieve: true
              })
            }
            this.isLoading = false
            this.getComments()
          })
      },
      getAllDrivers: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'drivers-search/?id_driver__id_type_driver_status=1')
          .then(response => {
            console.log('Drivers Response: ', response.data)
            this.data.drivers = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Unable to retrieve drivers!', {
              theme: 'bubble',
              position: this.toastPosition,
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      getFavoriteDrivers: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'users/?type=favorite&id=' + this.$route.params.id_user)
          .then(response => {
            console.log('Favorites Response: ', response.data)
            this.data.favoriteDrivers = response.data.results
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Unable to retrieve drivers!', {
              theme: 'bubble',
              position: this.toastPosition,
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      getBlacklistDrivers: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'users/?type=blacklist&id=' + this.$route.params.id_user)
          .then(response => {
            console.log('Blacklists Response: ', response.data)
            this.data.blacklistDrivers = response.data.results
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Unable to retrieve drivers!', {
              theme: 'bubble',
              position: this.toastPosition,
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      showDriverSelectModalAction: function (type) {
        // console.log('Switching to type: ', type)
        this.data.currentDriverSelect = type
        this.data.showDriverSelectModal = true
      },
      fbDriver: function (id, type, option) {
        // console.log("Editing: ", id.toString(), ' Type: ', type, ' Option: ', option)
        // Type = favorite/blacklist
        // Option = add/remove
        if (id.toString().startsWith('{') || id.toString().startsWith('[')) {
          id = document.getElementById("driver-selection").value.split(" ")[0]
          console.log("Driver selected: ", id)
        }

        if(id == this.data.driverSelectMessage) {
          Vue.toasted.show('Please select a driver', {
            theme: 'bubble',
            position: this.toastPosition,
            duration: 2000
          })
        }

        if ("favorite" == option) {
          this.isLoading = true
          this.$http
          .post(process.env.API_BASE_URL_CS + "favorite-driver/", {
              id_rider: this.$route.params.id_user,
              id_driver: id,
            })
            .then((response) => {
              this.isLoading = false
              this.getFavoriteDrivers()
              this.getBlacklistDrivers()
            })
            .catch((error) => {
              this.check403(error);
              if (error.response.status == 401) {
                console.warn("redirect to login");
                this.handle401();
              }
              console.log(error.response);
            })
            .finally(() => {
              this.hideLoading();
            });
        } else {
          this.isLoading = true
          this.$http
            .post(process.env.API_BASE_URL_CS + "blacklist-driver/", {
              id_rider: this.$route.params.id_user,
              id_driver: id,
              id_user_action: this.getUser().id_user,
            })
            .then((response) => {
              this.isLoading = false
              this.getFavoriteDrivers()
              this.getBlacklistDrivers()
            })
            .catch((error) => {
              this.check403(error);
              if (error.response.status == 401) {
                console.warn("redirect to login");
                this.handle401();
              }
              console.log(error.response);
            })
            .finally(() => {
              this.hideLoading();
            });
        }
      },
      editDriver: function (id, type, option) {
        // console.log("Editing: ", id.toString(), ' Type: ', type, ' Option: ', option)
        // Type = favorite/blacklist
        // Option = add/remove
        if (id.toString().startsWith('{') || id.toString().startsWith('[')) {
          id = document.getElementById("driver-selection").value.split(" ")[0]
          console.log("Driver selected: ", id)
        }

        if(id == this.data.driverSelectMessage) {
          Vue.toasted.show('Please select a driver', {
            theme: 'bubble',
            position: this.toastPosition,
            duration: 2000
          })
        }

        this.isLoading = true
        this.$http
          .post(process.env.API_BASE_URL_CS + 'driver-options/?type=' + type + '&option=' + option,
            {id_rider: this.$route.params.id_user,
              id_driver: id})
          .then(response => {
            console.log('Remove Response: ', response.data)
            this.isLoading = false
            this.getFavoriteDrivers()
            this.getBlacklistDrivers()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Unable to update driver', {
              theme: 'bubble',
              position: this.toastPosition,
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
            this.isLoading = false
          })
          .finally(() => {

          })
      },
    },

    mounted () {
      console.log('i am in');
      this.getUserProfile()
      this.getAllDrivers()
      this.getFavoriteDrivers()
      this.getBlacklistDrivers()
    },
    created () {
      // document.title = "Wingz Support | Riders";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .actions button {
    color: #333268;
    background-color: #00f9b9;
    border: none;
    margin-bottom: 5px;
  }

  .actions button:hover {
    background-color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/Users.vue